<template>
  <div class="big">
    <div>
      <div class="toptitle">
        <div style="display:flex;align-items: center;">
          <div>特色科室详情</div>
        </div>
        <el-button
          type="primary"
          style="width:92px;"
          size="medium"
          @click="back"
        >返回</el-button>
      </div>
    </div>

    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div>
          <div>
            <el-menu
              :default-active="activeIndex"
              class="el-menu-demo noneline"
              mode="horizontal"
              @select="handleSelect"
            >
              <el-menu-item
                index="1"
                class="title"
                style="font-size:16px"
              >科室信息</el-menu-item>

              <el-menu-item
                index="2"
                class="title space"
                style="font-size:16px"
                :disabled="module_id_array[0]?!module_id_array.includes('275'):false"
              >医生维护</el-menu-item>
              <el-menu-item
                index="3"
                class="title space"
                style="font-size:16px"
                :disabled="module_id_array[0]?!module_id_array.includes('282'):false"
              >患教文章</el-menu-item>
            </el-menu>
          </div>
          <div class="box">
            <div class="component">
              <component :is="currentComponent" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DepartmentMsg from './DepartmentMsg';
import Doctor from './Doctor';
import Essay from './Essay';

export default {
  data() {
    return {
      activeIndex: '1',
      active: '',
      status: ''
    };
  },
  computed: {
    currentComponent() {
      switch (this.active) {
        case '1':
          return DepartmentMsg;
        case '2':
          return Doctor;
        case '3':
          return Essay;
        default:
          return DepartmentMsg;
      }
    },
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array || [];
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.active = key;
    },
    back() {
      history.back();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;

  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
.toptitle {
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0 24px;
  box-sizing: border-box;
  font-size: 18px;
  background: #fbfbfb;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .status {
    color: #f24b2f;
    background: #ffe4dd;
    border-radius: 2px;
    font-size: 12px;
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    margin-left: 30px;
  }
}
</style>
